import React from 'react';
import Image from '@mlb/react-patterns/v4/components/Image/image';

const fetchImgAsset = (path, assetsBaseUrl, options) => {

    return (
        <Image
            src={ `${assetsBaseUrl}${path}` }
            { ...options }
        />
    )
};

export default fetchImgAsset;
